import { graphql } from 'gatsby';
import {
  StyledDescription,
  StyledContainer,
  StyledTitle,
  StyledIcon,
} from './StatBarBlockItem.styles';

const StatBarBlockItem = ({ elements }: Queries.STATBAR_BLOCK_ITEMFragment) => {
  const { description, title, icon } = elements;

  return (
    <StyledContainer>
      {icon?.value && <StyledIcon {...icon.value} />}
      <StyledTitle>{title.value}</StyledTitle>
      <StyledDescription>{description.value}</StyledDescription>
    </StyledContainer>
  );
};

export default StatBarBlockItem;

export const fragment = graphql`
  fragment STATBAR_BLOCK_ITEM on kontent_item_statbar_block_item {
    system {
      id
    }
    elements {
      description {
        value
      }
      title {
        value
      }
      icon {
        value {
          url
        }
      }
    }
  }
`;
